<template>
	<div class="status">
		<div :class="[status ? 'active': 'inactive', 'ball']"></div>
		<span>{{ status ? 'Ativo' : 'Inativo'}}</span>
	</div>
</template>

<script>
export default {
	name: 'ItemStatus',
	props: ['status']
}
</script>

<style lang="scss" scoped>
	.status {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: $font-size;

		.ball{
			width: 11px;
			height: 11px;
			border-radius: 10px;
			margin-right: 5px;

			&.active {
				background-color: $success-color;
			}

			&.inactive {
				background-color: $danger-color;
			}
		}
	}
</style>
